import { createTheme } from "@mui/material/styles";
import { AppColors } from "./constants/AppColors";

export const theme = createTheme({
  palette: {
    primary: { main: AppColors.primary },
    background: { default: AppColors.background, paper: AppColors.surface },
    text: {
      primary: AppColors.textPrimary,
      secondary: AppColors.textSecondary,
    },
    error: { main: AppColors.danger },
    success: { main: AppColors.success },
    warning: { main: AppColors.warning },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily:
      "Inter, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", borderRadius: 14, fontWeight: 800 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          boxShadow: "0 14px 40px rgba(15, 23, 42, 0.06)",
        },
      },
    },
  },
});
